export default "__VITE_ASSET__BfsHnEpC__"